import { h } from '@/components/dom';
import type { App } from './App';

export function createStatusBar(app: App): HTMLElement {
  const dot = h('span', { class: 'status__dot' });
  const text = h('span', { class: 'status__text' });
  const right = h('span', { class: 'status__right' });
  const el = h('div', { class: 'status', attrs: { role: 'status' } }, dot, text, right);
  app.store.subscribe((s, p) => {
    if (s.status !== p.status || s.statusMessage !== p.statusMessage || s.error !== p.error || s === p) {
      dot.dataset.status = s.status;
      text.textContent = s.error && s.status === 'error' ? s.error : s.statusMessage;
      text.classList.toggle('is-error', Boolean(s.error) && s.status === 'error');
    }
    if (s.wasmVersion !== p.wasmVersion || s.target !== p.target || s === p) {
      right.textContent = [s.target.width ? `${s.target.width}×${s.target.height}` : null, s.wasmVersion ? `core ${s.wasmVersion}` : null].filter(Boolean).join(', ');
    }
  }, { immediate: true });
  return el;
}
